"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFinalCheck = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackFinalCheck(selectedGender, clickUrl) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: enums_1.EventAction.BoxClick,
        eventLabel: 'Proceed to final check',
        eventData: {
            eventName: enums_1.GA4EventName.ClickEcomCta,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            click_element: enums_1.ClickElement.ProceedToLastCheck,
            click_text: enums_1.ClickText.LastCheck,
            selected_gender: selectedGender,
            click_url: clickUrl,
        },
    });
}
exports.trackFinalCheck = trackFinalCheck;
//# sourceMappingURL=trackFinalCheck.js.map